module.exports = __webpack_public_path__ + "static/img/3.36d7c22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/3.jpg
// module id = hU4X
// module chunks = 70